// Cloudflare Turnstile Configuration
export const CLOUDFLARE_CONFIG = {
  // Replace with your actual Cloudflare Turnstile site key
  // You can get this from your Cloudflare dashboard
  TURNSTILE_SITE_KEY:
    import.meta.env.VITE_TURNSTILE_SITE_KEY || "0x4AAAAAAABX_mVWXnt2scLh",

  // Default theme (light or dark)
  DEFAULT_THEME: "light" as const,

  // Default size (normal, compact, or invisible)
  DEFAULT_SIZE: "normal" as const,
};

// Helper function to get the site key
export const getTurnstileSiteKey = (): string => {
  return CLOUDFLARE_CONFIG.TURNSTILE_SITE_KEY;
};
